export type Status = "boot" | "compiling" | "ok" | "error";

const DOT: Record<Status, string> = {
  boot: "● inicializando",
  compiling: "● compilando…",
  ok: "● ok",
  error: "● error",
};

// Bottom status bar: compile state dot, the current error (if any) or the
// "this template uses a photo" hint, and the local-autosave note.
export function StatusBar({
  status,
  error,
  needsPhoto,
  notice,
}: {
  status: Status;
  error: string | null;
  needsPhoto: boolean;
  notice?: string | null;
}) {
  return (
    <footer className="flex items-center gap-3 border-t border-line bg-panel px-4 py-1.5 font-mono text-[11px]">
      <span
        className={
          status === "error"
            ? "text-danger"
            : status === "compiling" || status === "boot"
              ? "text-mute"
              : "text-success"
        }
      >
        {DOT[status]}
      </span>
      {error && (
        <span className="min-w-0 flex-1 truncate text-danger" title={error}>
          {error}
        </span>
      )}
      {!error && notice && (
        <span className="min-w-0 flex-1 truncate text-success" title={notice}>
          {notice}
        </span>
      )}
      {!error && !notice && needsPhoto && (
        <span className="min-w-0 flex-1 truncate text-accent">
          Esta plantilla usa foto — pulsa «foto» para subir la tuya (ahora se
          ve un marcador).
        </span>
      )}
    </footer>
  );
}
